export default __webpack_public_path__ + "static/companies-one-ef7c0e9bfa3650de2ba4f4a233428cdf.jpg";